import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from './ui/sheet';
const navLinks = [{
  name: 'Home',
  path: '/'
}, {
  name: 'About',
  path: '/about'
}, {
  name: 'Services',
  path: '/services'
}, {
  name: 'Leadership',
  path: '/leadership'
}, {
  name: 'Global Network',
  path: '/global-network'
}, {
  name: 'Contact',
  path: '/contact'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy/95 backdrop-blur-md shadow-lg' : 'bg-navy'}`} data-id="element-30">
      <div className="container mx-auto px-4 lg:px-8" data-id="element-31">
        <div className="flex items-center justify-between h-20 lg:h-24" data-id="element-32">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 flex-shrink-0" data-id="element-33">
            <img src="https://cdn.magicpatterns.com/uploads/hWmdhijhRkkJmHjpaF6M76/smg-logo.png" alt="Strategic Metals Group" className="h-12 w-12 lg:h-14 lg:w-14 object-contain" data-id="element-34" />
            <span className="hidden md:block text-white font-heading text-lg lg:text-xl font-semibold leading-tight" data-id="element-35">
              Strategic Metals
              <br className="hidden lg:block" data-id="element-36" /> Group
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8" data-id="element-37">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium font-body transition-colors relative group whitespace-nowrap ${location.pathname === link.path ? 'text-gold' : 'text-white/90 hover:text-gold'}`} data-id="element-38">
                {link.name}
                <span className={`absolute -bottom-1 left-0 w-full h-0.5 bg-gold transform origin-left transition-transform duration-300 ${location.pathname === link.path ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'}`} data-id="element-39" />
              </Link>)}
          </nav>

          {/* CTA Button - Desktop */}
          <div className="hidden lg:block flex-shrink-0" data-id="element-40">
            <Button asChild className="bg-gold hover:bg-gold-dark text-navy font-semibold text-sm" data-id="element-41">
              <Link to="/contact" data-id="element-42">Schedule Consultation</Link>
            </Button>
          </div>

          {/* Mobile Menu */}
          <div className="lg:hidden" data-id="element-43">
            <Sheet open={isOpen} onOpenChange={setIsOpen} data-id="element-44">
              <SheetTrigger asChild data-id="element-45">
                <Button variant="ghost" size="icon" className="text-white hover:text-gold" data-id="element-46">
                  <Menu className="h-6 w-6" data-id="element-47" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="bg-navy border-gold/20 w-80" data-id="element-48">
                <SheetHeader data-id="element-49">
                  <SheetTitle className="text-white font-heading text-xl text-left" data-id="element-50">
                    Menu
                  </SheetTitle>
                </SheetHeader>
                <nav className="flex flex-col space-y-1 mt-8" data-id="element-51">
                  {navLinks.map(link => <Link key={link.path} to={link.path} onClick={() => setIsOpen(false)} className={`text-lg font-medium font-body transition-all duration-200 py-3 px-4 rounded-lg ${location.pathname === link.path ? 'text-gold bg-navy-light border-l-2 border-gold' : 'text-white/90 hover:text-gold hover:bg-navy-light'}`} data-id="element-52">
                      {link.name}
                    </Link>)}
                  <div className="pt-4" data-id="element-53">
                    <Button asChild className="bg-gold hover:bg-gold-dark text-navy font-semibold w-full" data-id="element-54">
                      <Link to="/contact" onClick={() => setIsOpen(false)} data-id="element-55">
                        Schedule Consultation
                      </Link>
                    </Button>
                  </div>
                </nav>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>;
}